{
  "version": "v4.3.0",
  "name": "SwapWithoutAccount",
  "bytecodeTemplate": "010103000400402cb41700{0}160047cc17011601c5194c0516000d0c{0}d465b302f9{5}3d1702{5}05264c02{2}4a01{3}17031600{2}1602a3160016001603{4}{5}{6}{7}13070e{1}012a1818",
  "fieldsSig": {
    "names": [
      "dexAccount",
      "pool",
      "tokenIn",
      "tokenOut",
      "zeroForOne",
      "amountSpecified",
      "sqrtPriceLimitX96",
      "data"
    ],
    "types": [
      "IDexAccount",
      "Pool",
      "ByteVec",
      "ByteVec",
      "Bool",
      "I256",
      "U256",
      "ByteVec"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}